import React, { useState } from "react";

import educationImg from "../../assets/education.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot } from "react-icons/fa";
import { MdMenuBook } from "react-icons/md";

const styles = `
  /* ── HEADER ── */
  .edu-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .edu-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .edu-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .edu-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .edu-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .edu-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .edu-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .edu-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .edu-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .edu-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  /* ── MAIN ── */
  .edu-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .edu-image-wrap {
    flex: 1;
  }

  .edu-image-wrap img {
    width: 100%;
    max-width: 650px;
  }

  .edu-accordion {
    flex: 1.2;
  }

  .edu-accordion-item {
    margin-bottom: 18px;
  }

  .edu-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
  }

  .edu-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .edu-header {
      height: auto;
      min-height: 90px;
    }

    .edu-header-badge {
      width: auto;
      padding: 10px 14px;
      font-size: 14px;
    }

    .edu-header-title h2 {
      font-size: 22px;
    }

    .edu-triangle-left,
    .edu-triangle-right {
      width: 50px;
    }

    .edu-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .edu-header {
      flex-direction: column;
      height: auto;
    }

    .edu-header-left {
      flex: none;
      height: 80px;
      padding: 0 16px;
    }

    .edu-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
    }

    .edu-header-right {
      flex: none;
      height: 70px;
      border-top: 1px solid #e5e5e5;
    }

    .edu-triangle-left,
    .edu-triangle-right {
      width: 40px;
    }

    .edu-header-title h2 {
      font-size: 18px;
    }

    .edu-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .edu-image-wrap {
      width: 100%;
      text-align: center;
    }

    .edu-image-wrap img {
      max-width: 100%;
    }

    .edu-accordion {
      width: 100%;
      flex: none;
    }

    .edu-accordion-header {
      font-size: 14px;
      padding: 10px 16px;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .edu-header-left {
      height: 70px;
      padding: 0 12px;
    }

    .edu-header-badge {
      font-size: 12px;
      padding: 8px 10px;
      gap: 8px;
    }

    .edu-header-icon-box {
      width: 28px;
      height: 28px;
    }

    .edu-header-right {
      height: 60px;
    }

    .edu-header-title h2 {
      font-size: 15px;
    }

    .edu-triangle-left,
    .edu-triangle-right {
      width: 28px;
    }

    .edu-main {
      padding: 20px 14px;
      gap: 24px;
    }

    .edu-accordion-header {
      font-size: 13px;
      padding: 9px 12px;
    }

    .edu-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }

    .edu-accordion-item {
      margin-bottom: 12px;
    }
  }
`;

function EducationPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Personalized Learning",
      content:
        "AI-based personalized teaching can cater to specific needs and identify effective learning patterns."
    },
    {
      title: "2.AI Application in Quality Control",
      content:
        "AI systems provide virtual support like chatbots enabling real-time communication for students."
    },
    {
      title: "3.Automated Grading",
      content:
        "AI tools can evaluate assignments quickly and accurately, saving teacher time."
    },
    {
      title: "4.Smart Content Creation",
      content:
        "AI helps generate digital learning materials, summaries, and visual content."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="edu-header">

        {/* LEFT */}
        <div
          className="edu-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="edu-header-overlay" />

          <div className="edu-header-badge">
            <div className="edu-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="edu-header-right">
          <div className="edu-triangle-left" />
          <div className="edu-triangle-right" />

          <div className="edu-header-title">
            <MdMenuBook style={{ fontSize: "32px", color: "#2fb7a4", flexShrink: 0 }} />
            <h2>Education</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN ===== */}
      <div className="edu-main">

        {/* IMAGE */}
        <div className="edu-image-wrap">
          <img src={educationImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="edu-accordion">
          {data.map((item, i) => (
            <div key={i} className="edu-accordion-item">
              <div
                className="edu-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span style={{ fontSize: "22px" }}>
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="edu-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EducationPage;
